import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-customers-page">
      <div className="text-xs uppercase tracking-[0.2em] text-[#2563eb] font-semibold">Customers</div>
      <h1 className="mt-1 font-display font-bold text-3xl text-[#0f1b2d]">All Customers</h1>

      <div className="mt-6 bg-white border border-[#e2e8f0] rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#f8fafc] text-xs uppercase tracking-wider text-[#64748b]">
              <tr>
                <th className="text-left px-4 py-3">Name</th>
                <th className="text-left px-4 py-3">Email</th>
                <th className="text-left px-4 py-3">Orders</th>
                <th className="text-left px-4 py-3">Total Spent</th>
                <th className="text-left px-4 py-3">Joined</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={5} className="px-4 py-10 text-center text-[#475569]">Loading…</td></tr>
              ) : customers.length === 0 ? (
                <tr><td colSpan={5} className="px-4 py-10 text-center text-[#475569]">No customers yet.</td></tr>
              ) : (
                customers.map((c) => (
                  <tr key={c.id} className="border-t border-[#e2e8f0]" data-testid={`customer-${c.id}`}>
                    <td className="px-4 py-3 text-[#0f1b2d] font-medium">{c.name}</td>
                    <td className="px-4 py-3 text-[#475569]">{c.email}</td>
                    <td className="px-4 py-3 text-[#0f1b2d]">{c.order_count}</td>
                    <td className="px-4 py-3 font-display font-bold text-[#0f1b2d]">${Math.round(c.total_spent)}</td>
                    <td className="px-4 py-3 text-xs text-[#64748b]">{(c.created_at || "").slice(0, 10)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
